module.exports = __webpack_public_path__ + "static/media/banner-home-comfort.b165750a.jpg";